import ReactGA from "react-ga4";
import { GA_MEASUREMENT_ID } from "./util/constants/constants";

if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

export default ReactGA;
